// JOG-KAPUZOTT MŰVELET — a `design.md` → „Jog-kapuzás" 1. rétegének burkolója.
//
// A konvenció: MŰVELETET nem rejtünk el, hanem TILTUNK magyarázó tooltippel („a funkció létezik, csak neked
// nincs hozzá jogod"). A technikai csavar, ami miatt ez nem egy `disabled` prop: a tiltott gomb NEM tüzel
// pointer-eventet, tehát a Radix-tooltip trigger fókuszálható burkolót igényel — ezt a mintát a repo eddig
// HÁROM helyen írta le kézzel (`list-new-button`, `list-row-actions`, `list-export-button`), és minden új
// kapuzott akció egy negyedik példány lett volna.
//
// A GOMBOT a hívó adja (bármilyen variáns/méret/ikon) — ez a komponens csak a kaput adja hozzá; a `disabled`
// állítása a hívó dolga, mert a gomb szövege és ikonja is az övé. A három meglévő lista-komponens
// SZÁNDÉKOSAN érintetlen: azok működnek, az átállításuk saját, fókuszált kör.
import type { ReactNode } from 'react';

import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip';

interface GatedActionProps {
  /** Van-e joga/lehetősége a műveletre. `true` → a gyerek változatlanul, burkoló nélkül renderel. */
  allowed: boolean;
  /** A tooltip szövege jog hiányában — a HIÁNYZÓ jogot/okot mondja ki, nem a művelet leírását. */
  reason: string;
  children: ReactNode;
}

export function GatedAction({ allowed, reason, children }: GatedActionProps): JSX.Element {
  if (allowed) return <>{children}</>;
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <span tabIndex={0}>{children}</span>
      </TooltipTrigger>
      <TooltipContent>{reason}</TooltipContent>
    </Tooltip>
  );
}
